  
import axios from 'axios';
 
class HackerService {
  putPayPalAccount(payload) {
    return axios.put(`hacker/billing/paypal_account`, payload); 
  } 
  getProfile(id) {
    return axios.get(`hacker/profile/${id}`); 
  } 
  putHackerEmailAuthentication(payload) { 
    return axios.put( `/hacker/email-code`, payload); 
  }
}

export default new HackerService();